import { MtBase } from './MtBase';

export class MtObject extends MtBase {
  GeometryType?: string;
  GeObjectId: string;
  GeObjectType: number;
}
